<template>
    <div
        style="padding: 10px;margin: 0 0 25px 0;background: #F5F5F5;border:1px solid #BDBDBD;border-radius: 5px;"
    >
        <span
            style="font-size: 18px;"
        >
            <b>{{ local_template ? local_template.name : '...' }}</b>
        </span>
    </div>
</template>

<script>
import api from '@/api'

export default {
    props: ['id', 'template'],
    data () {
      return {
        local_template: null,
        searching: false
      }
    },
    created () {
        if (this.template) {
            this.local_template = JSON.parse(JSON.stringify(this.template))
        } else {
            if (this.id)
                this.loadFormTemplates()
        }
    },
    methods: {
        loadFormTemplates () {
            this.searching = true
            api.formtemplate.formtemplate.get(this.id)
                .then(data => {
                    this.searching = false
                    this.local_template = data
                })
        },
    }
}
</script>